import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { getServicesUrl, V11 } from '../../setup';
import Service from './service';
import common from './common';

var Security =
/*#__PURE__*/
function (_Service) {
  _inherits(Security, _Service);

  function Security() {
    _classCallCheck(this, Security);

    return _possibleConstructorReturn(this, _getPrototypeOf(Security).apply(this, arguments));
  }

  _createClass(Security, [{
    key: "activateUser",
    value: function activateUser(activationKey) {
      var that = this;
      return new Promise(function (resolve, reject) {
        Service.postRequest("".concat(getServicesUrl(), "/contacts/activate"), {
          ActivationKey: activationKey
        }).then(function (response) {
          that.forgotPasswordUserId = response.data.ContactId;
          resolve(response.data);
        }).catch(function (reason) {
          reject(reason);
        });
      });
    }
  }], [{
    key: "registerPrivateUser",
    value: function registerPrivateUser(data) {
      return Service.postRequest("".concat(getServicesUrl(), "/contacts/register"), data);
    }
  }, {
    key: "registerCorporateUser",
    value: function registerCorporateUser(data) {
      return Service.postRequest("".concat(getServicesUrl(), "/contacts/register"), data);
    }
  }, {
    key: "changePassword",
    value: function changePassword(activationKey, password, confirmPassword) {
      return Service.postRequest("".concat(getServicesUrl(), "/authentication/reset-password"), {
        ActivationKey: activationKey,
        Password: password,
        ConfirmPassword: confirmPassword
      });
    }
  }, {
    key: "logIn",
    value: function logIn(username, password) {
      return Service.postRequest("".concat(getServicesUrl(), "/authentication/authenticate"), {
        userName: username,
        password: password,
        ForceExpiringPreviousSession: true
      });
    }
  }, {
    key: "lengthOfMTan",
    value: function lengthOfMTan() {
      var group = 'MTan';
      var key = 'Length';
      return common.getGlobalSettingByGroupAndKey(group, key);
    }
  }, {
    key: "forgotPassword",
    value: function forgotPassword(_ref) {
      var username = _ref.username,
          email = _ref.email;
      return Service.postRequest("".concat(getServicesUrl(V11), "/authentication/forgotten-password"), {
        Email: email,
        UserName: username
      });
    }
  }, {
    key: "forgotPasswordMtan",
    value: function forgotPasswordMtan(code, contactId) {
      return Service.postRequest("".concat(getServicesUrl(), "/contacts/").concat(contactId, "/authentication/forgotten-password/mtan"), {
        MTan: code,
        RedirectUrl: "".concat(global.location.origin, "/reset-password")
      });
    }
  }, {
    key: "checkSession",
    value: function checkSession(contactId, dfsSessionId) {
      return Service.getRequest("".concat(getServicesUrl(V11), "/contacts/").concat(contactId, "/authentication/tokens/").concat(dfsSessionId));
    }
  }, {
    key: "logIn2",
    value: function logIn2(_ref2) {
      var username = _ref2.username,
          password = _ref2.password,
          trustedDeviceToken = _ref2.trustedDeviceToken;
      return Service.postRequest("".concat(getServicesUrl(V11), "/authentication/pre-authenticate"), {
        UserName: username,
        Password: password,
        ForceExpiringPreviousSession: true,
        TrustedDeviceToken: trustedDeviceToken
      });
    }
  }, {
    key: "authenticate",
    value: function authenticate(contactId, _ref3) {
      var passcode = _ref3.passcode,
          setTrusted = _ref3.setTrusted;
      return Service.postRequest("".concat(getServicesUrl(V11), "/contacts/").concat(contactId, "/authentication/authenticate"), {
        Passcode: passcode,
        SetTrusted: setTrusted
      });
    }
  }, {
    key: "authenticateStatus",
    value: function authenticateStatus(username, authStatusSessionId) {
      return Service.postRequest("".concat(getServicesUrl(V11), "/authentication/authenticate/status"), {
        UserName: username,
        AuthStatusSessionId: authStatusSessionId
      }, {
        withCancel: true
      });
    }
  }, {
    key: "validateToken",
    value: function validateToken(_ref4) {
      var accessToken = _ref4.accessToken;
      return Service.postRequest("".concat(getServicesUrl(), "/authentication/tokens/validate"), {
        AccessToken: accessToken
      }, {
        withCancel: true
      });
    }
  }, {
    key: "mtan",
    value: function mtan(contactId, code) {
      return Service.postRequest("".concat(getServicesUrl(), "/contacts/").concat(contactId, "/authentication/authenticate/mtan"), {
        mTan: code
      });
    }
  }]);

  return Security;
}(Service);

export default Security;
export var security = new Security();